import {
  ClampToEdgeWrapping,
  LinearFilter,
  LinearMipmapLinearFilter,
  NearestFilter,
  NoColorSpace,
  RepeatWrapping,
  type Texture,
} from "three/webgpu";
import type { TextureWrap } from "./GpuContext.js";

/** Anything the renderer can sample as an image. */
export interface DrawableTexture {
  readonly texture: Texture;
  readonly width: number;
  readonly height: number;
  /** True when the color is already multiplied by alpha, as a rendered scene's is. */
  readonly premultiplied?: boolean;
}

/**
 * Configure a texture the way every Webwin texture is sampled: rows top-first (`v = 0` is the top of the
 * picture, on both backends), the stored values used as they are, and the filter and wrap asked for.
 */
export function configureTexture<T extends Texture>(texture: T, smooth = true, wrap: TextureWrap = "clamp", mips = false, anisotropy = 1): T {
  texture.flipY = false;
  texture.colorSpace = NoColorSpace;
  texture.premultiplyAlpha = false;
  texture.generateMipmaps = mips;
  texture.magFilter = smooth ? LinearFilter : NearestFilter;
  texture.minFilter = smooth ? (mips ? LinearMipmapLinearFilter : LinearFilter) : NearestFilter;
  texture.anisotropy = smooth ? anisotropy : 1;
  texture.wrapS = texture.wrapT = wrap === "repeat" ? RepeatWrapping : ClampToEdgeWrapping;
  return texture;
}
